import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import { confirmPasswordCognitoUser } from '@utils/authenticateService'
import { IConfirmPasswordPayload } from '@app-store/slices/auth/confirmPassword.slice'
import { notification } from 'antd'
import { history } from '@components/App'
import routes from '@utils/constants/routes'

interface TaskAction extends Action, ITask {}
interface ITask {
    payload: IConfirmPasswordPayload
}

const { onFailure, onSuccess, onRequest } = rootActions.auth.confirmPassword

function* confirmPasswordSagaTask({ payload }: TaskAction) {
    try {
        const response = yield confirmPasswordCognitoUser(payload)
        history.replace({
            pathname: routes.login._
        })
        notification.success({
            message: 'Your password has been changed successfully.'
        })
        yield put(onSuccess(response))
    } catch (e) {
        yield put(onFailure([e || 'Something went wrong.']))
        notification.error({
            message: e || 'Something went wrong.'
        })
    }
}

function* confirmPasswordSaga(): any {
    yield takeLatest<TaskAction>(onRequest, confirmPasswordSagaTask)
}

export default confirmPasswordSaga
